
























import Reflect from "reflect-metadata";
import { Component, Vue, Prop } from "vue-property-decorator";
import { User } from "@/models/User";
import sessionService from "@/services/SessionService";

@Component
export default class DocumentExportMenu extends Vue {
  isOpen!: boolean;
  sessionUser!: User | null;

  @Prop({ default: false })
  private loading!: boolean;

  downloadCsvPage() {
    if (!this.loading) {
      this.$root.$emit("export:page:csv");
    }
  }

  downloadCsvFilter() {
    if (!this.loading) {
      this.$root.$emit("export:filter:csv");
    }
  }

  constructor() {
    super();
    this.sessionUser = sessionService.getUser();
    this.isOpen = false;
  }
}
